module.exports = __webpack_public_path__ + "static/assets/4f9651f641d2237cc7f1011185e9efc4.svg";